import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import withLocalLoader from 'components/HOCs/withLocalLoader';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import ConstructionOutlined from '@mui/icons-material/ConstructionOutlined';
import Button from 'tailwind-components/Button/Button';
import DashboardBob from './DashboardBob';
import { getCompany, getFrontendInstance } from 'helpers/getCompanyVariables';
import { isMobileWebView, postMobileNavigate } from 'helpers/mobileWebView';

const company = getCompany();

const env = getFrontendInstance();

function mapStateToProps({}) {
  return {};
}
function DashboardBobWrapper({ riskManagement = false }) {
  const pageTitle = riskManagement ? 'Risk Management' : 'CustomersBob';

  const Enhanced = withLocalLoader(DashboardBob, false, pageTitle, pageTitle);

  return <Enhanced riskManagement={riskManagement} />;
}

DashboardBobWrapper.propTypes = {
  riskManagement: PropTypes.bool
};

function DashboardBobMaintenanceContent({ setLocalLoader }) {
  const navigate = useNavigate();

  useEffect(() => {
    setLocalLoader(false);
  }, [setLocalLoader]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100%',
        gap: 2,
        px: 2,
        textAlign: 'center',
        backgroundColor: 'white',
        borderRadius: 3
      }}
    >
      <ConstructionOutlined
        sx={{ fontSize: 72, color: 'text.secondary', opacity: 0.85 }}
        aria-hidden
      />
      <Typography variant='h5' component='h1'>
        Under maintenance
      </Typography>
      <Typography variant='body1' color='text.secondary' sx={{ maxWidth: 420 }}>
        This area is temporarily unavailable. Please check back later or return
        to the home page.
      </Typography>
      <Button
        variant='primaryLight'
        text='Go to home'
        onClick={() =>
          isMobileWebView() ? postMobileNavigate('/home') : navigate('/')
        }
      />
    </Box>
  );
}

DashboardBobMaintenanceContent.propTypes = {
  setLocalLoader: PropTypes.func.isRequired
};

function DashboardBobMaintenanceWrapper({ riskManagement = false }) {
  const pageTitle = riskManagement ? 'Risk Management' : 'CustomersBob';

  const Enhanced = withLocalLoader(
    DashboardBobMaintenanceContent,
    false,
    pageTitle,
    pageTitle
  );

  return <Enhanced riskManagement={riskManagement} />;
}

DashboardBobMaintenanceWrapper.propTypes = {
  riskManagement: PropTypes.bool
};

export default connect(
  mapStateToProps,
  {}
)(
  company === 'sunshine' || env !== 'production'
    ? DashboardBobWrapper
    : DashboardBobMaintenanceWrapper
);
